<script>
  // The outside-scope card's bulk transfer banner (spec-addendum §C). The
  // common case is a whole rack that lives at another branch, so the bulk
  // action comes first and the per-row toggles handle the exceptions.
  //
  // Pre-apply it states the situation and offers one click for the whole
  // cross-branch set; once the bulk has staged rows it becomes a summary strip
  // whose Undo reverts only what the bulk itself staged — hand-toggled rows
  // survive it (that surgery lives in the store's undoBulkTransfer).
  //
  // It renders outside the card's collapsible body: the banner has to be usable
  // without expanding a single row (§D).
  export let eligibleCount = 0; // rows that can be transferred
  export let ineligibleCount = 0; // wrong type, but already homed here
  export let transferCount = 0; // rows currently staged to transfer, however staged
  export let branchName = "";
  export let applied = false; // the bulk staged rows its Undo still owns
  export let onTransferAll; // (alsoActive: boolean) => void
  export let onUndo;

  // Scanning a unit is evidence it is physically here, so the bulk offers the
  // Active default on by default (§A1) — declinable before applying, and
  // overridable per row afterwards.
  let alsoActive = true;
</script>

{#if applied}
  <div class="recon-transfer-banner applied">
    <span class="rb-text">
      <strong>
        <span class="rb-check"><i class="fas fa-check-circle" /></span>
        {transferCount} units transferring to {branchName}
      </strong>
      <span class="text-muted">adjust exceptions per row below</span>
    </span>
    <button class="btn btn-sm btn-outline-secondary" on:click={onUndo}>Undo bulk transfer</button>
  </div>
{:else}
  <div class="recon-transfer-banner">
    <span class="rb-text">
      <strong>
        {eligibleCount} of these {eligibleCount + ineligibleCount} units belong to another branch.
      </strong>
      {#if ineligibleCount > 0}
        <span class="text-muted">
          The {ineligibleCount} wrong-type units already homed here are status-only.
        </span>
      {/if}
    </span>
    <label class="rb-also small">
      <input type="checkbox" bind:checked={alsoActive} />
      also set transferred units to Active
    </label>
    <button class="btn btn-primary" on:click={() => onTransferAll(alsoActive)}>
      <span><i class="fas fa-exchange-alt me-1" /></span>Transfer all {eligibleCount} here
    </button>
  </div>
{/if}

<style>
  .recon-transfer-banner {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.75rem 1rem;
    background: #fff8f0;
    border-top: 1px solid #eceff2;
    border-bottom: 1px solid #eceff2;
  }
  /* staged: the card stops asking and starts reporting */
  .recon-transfer-banner.applied {
    background: #eef4fb;
  }
  .rb-text {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    font-size: 0.9rem;
  }
  .rb-check {
    color: #198754;
  }
  .rb-also {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    white-space: nowrap;
    margin: 0;
  }
</style>
